"use client";

import React from "react";
import { Code, Laptop } from "lucide-react";
import { CompanyInfoCard } from "./CompanyInfoCard";
import { Badge } from "@/components/ui/badge";
import type { CompanyEntity } from "@/lib/types/company";

interface CompanyTechnologiesProps {
  company: CompanyEntity;
}

export function CompanyTechnologies({ company }: CompanyTechnologiesProps) {
  if (!company.current_technologies) return null;

  let technologies: string[] = [];

  try {
    if (typeof company.current_technologies === "string") {
      const parsed = JSON.parse(company.current_technologies);
      if (Array.isArray(parsed)) {
        technologies = parsed.filter(t => typeof t === "string" && t.trim());
      } else if (parsed && typeof parsed === "object") {
        technologies = Object.keys(parsed).filter(k => k.trim());
      }
    } else if (Array.isArray(company.current_technologies)) {
      technologies = company.current_technologies.filter(t => typeof t === "string" && t.trim());
    } else if (typeof company.current_technologies === "object" && company.current_technologies !== null) {
      technologies = Object.keys(company.current_technologies).filter(k => k.trim());
    }
  } catch (e) {
    console.error("Failed to parse technologies:", e);
  }

  if (technologies.length === 0) return null;

  return (
    <CompanyInfoCard title="Technologies" icon={Code}>
      <div className="flex items-start gap-2">
        <Laptop className="h-4 w-4 text-gray-400 mt-0.5 flex-shrink-0" />
        <div className="flex-1">
          <div className="text-xs font-medium text-gray-500 uppercase tracking-wide mb-2">
            Current Stack
          </div>
          <div className="flex flex-wrap gap-2">
            {technologies.map((tech, index) => (
              <Badge key={index} variant="secondary" className="text-xs">
                {tech}
              </Badge>
            ))}
          </div>
        </div>
      </div>
    </CompanyInfoCard>
  );
}
